'use client';

import * as React from 'react';
export const EventCalendarStyledContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") EventCalendarStyledContext.displayName = "EventCalendarStyledContext";
export function useEventCalendarStyledContext() {
  const value = React.useContext(EventCalendarStyledContext);
  if (!value) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI X Scheduler: useEventCalendarStyledContext must be used within an EventCalendarStyledContext.Provider. ' + 'The component requires access to calendar styling and locale information. ' + 'Ensure the component is rendered inside an EventCalendar component.');
  }
  return value;
}